import { render, staticRenderFns } from "./AddTaskForm.vue?vue&type=template&id=c5108b18&"
import script from "./AddTaskForm.vue?vue&type=script&lang=js&"
export * from "./AddTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports